var _rect, _circle, _circle2, _line, _line2, _line3, _path, _path2, _path3, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWellness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    rx: 16,
    fill: "#f0fdf4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 75,
    r: 28,
    fill: "#fbbf24",
    opacity: 0.15
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 75,
    r: 18,
    fill: "#fbbf24",
    opacity: 0.1
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 40,
    x2: 200,
    y2: 30,
    stroke: "#fbbf24",
    strokeWidth: 2,
    opacity: 0.25,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 225,
    y1: 52,
    x2: 232,
    y2: 45,
    stroke: "#fbbf24",
    strokeWidth: 2,
    opacity: 0.25,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 175,
    y1: 52,
    x2: 168,
    y2: 45,
    stroke: "#fbbf24",
    strokeWidth: 2,
    opacity: 0.25,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180 140 C180 115 215 105 232 122 C250 140 232 175 210 175 C192 175 180 158 180 140Z",
    fill: "#dcfce7",
    stroke: "#16a34a",
    strokeWidth: 2,
    opacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192 165 C198 150 212 138 230 128",
    stroke: "#16a34a",
    strokeWidth: 1.5,
    fill: "none",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155 185 C155 172 168 166 176 174 C184 166 197 172 197 185 C197 202 176 215 176 215 C176 215 155 202 155 185Z",
    fill: "#f43f5e",
    opacity: 0.1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 262,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#166534"
  }, "Saglikli Yasam")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellness);
export default __webpack_public_path__ + "static/media/wellness.970d2fc5d29db2b8f786dda325025ada.svg";
export { ForwardRef as ReactComponent };